<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M3.33689 9.58949L2.29492 8.54752C0.568361 6.82096 0.568361 4.02148 2.29492 2.29492C4.02148 0.568361 6.82096 0.568361 8.54752 2.29492L9.58949 3.33689"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.4104 12.6628L7.45238 13.7047C9.17893 15.4313 11.9784 15.4313 13.705 13.7047C15.4315 11.9782 15.4315 9.17869 13.705 7.45213L12.663 6.41016"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.2107 10.2105L5.78931 5.78906"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
